import { PaymentRequestGetAdapter } from '../../../adapter';

export default async function PaymentRequestGetUseCase(event) {
    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/payment-request/get';

    const payload = {
        data: {
            paymentRequestData: {
                ...event
            },
            signature: ''
        }
    };

    const result = await PaymentRequestGetAdapter(requestUrl, JSON.stringify(payload));
    return result;
}
